import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MyCommonModule } from 'src/app/modules/common/common.module';
import {OverlayModule } from '@angular/cdk/overlay';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import {LOCALE_ID} from '@angular/core';


@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], 
    imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MyCommonModule,
        OverlayModule,
        RouterModule,
        MatSnackBarModule,        
    ], 
    providers: [provideHttpClient(withInterceptorsFromDi()), {provide: LOCALE_ID, useValue: 'fr'}] })
export class AppModule { }
